

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ChiefComplaintsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface ChiefComplaints {
    id?: number;
    tenantId: any;
    branchId?: any;
    code: string;
    name:string;
    univ_Code?:string;
    mappingAttribute?:string;
    
    isActive?:Boolean;
  parameters?: ChiefComplaintsParameter[];
  links?: any;
  snomedCode?:string;
}

export abstract class ChiefComplaintsData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<ChiefComplaints[]>;
  abstract create(url: string, data: ChiefComplaints): Observable<ChiefComplaints[]>;
  abstract update(url: string, data: ChiefComplaints): Observable<ChiefComplaints>;
  abstract delete(url: string): Observable<any>;
  abstract createChiefCompMasterDtl(url: string, data: any): Observable<any[]>;
  abstract updateChiefCompMasterDtl(url: string, data: any): Observable<any>;

}
